import './DeleteConfirmationModal.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../modal/Modal';
import { type ModalProps } from '../modal/Modal';

const DeleteConfirmationModal: React.FC<ModalProps> = ({
    onClose,
    onCancel,
    onAction,
    isLoading,
    show,
    children
}) => {
    const { t } = useTranslation();
    return (
        <Modal
            className="delete-confirmation-modal"
            show={show}
            onClose={onClose}
            onCancel={onCancel}
            onAction={onAction}
            localeAction={t('delete')}
            localeCancel={t('cancel')}
            isLoading={isLoading}
            name='delete confirmation modal'
        >
            {children}
        </Modal>
    );
};

export default DeleteConfirmationModal;
